import { Button, Col, Row, Typography } from 'antd'
import { useContext, useState } from 'react'

import _ from 'lodash'
import AppContext from '../common/AppContext'
import BookingDisplay from './BookingDisplay'
import NextBookingMessage from './NextBookingMessage'

const { Title, Text, Paragraph } = Typography

const UpcomingBookings = ({ bookings, onSelected, nextAllowed, lastBooking, maxBookingTime }) => {
  const [showAll, setShowAll] = useState(true)
  const { currentUser } = useContext(AppContext)

  const MAX = 5

  const bookingsWithOwner = _.map(bookings, (b) => {
    return { ...b, isOwnBooking: b.createdByUser?.id === currentUser?.id }
  })

  const bookingsToShow = showAll ? bookingsWithOwner : bookingsWithOwner?.slice(0, MAX)
  const hiddenCount = _.size(bookings) - MAX

  return (
    <>
      <Row justify="start" style={{ width: '100%', marginTop: '1em' }}>
        <Col xs={24} sm={24} md={12} lg={9} xl={7} style={{ marginRight: '0em', marginBottom: '1em' }}>
          <>
            <Title level={3} className="noPad">
              My court bookings
            </Title>
            <div style={{ marginTop: '0.5em', overflowY: 'auto', maxHeight: '100px' }}>
              {!_.isEmpty(bookingsToShow) ? (
                <>
                  {bookingsToShow.map((booking) => {
                    return (
                      <>
                        <BookingDisplay title="Next booking" booking={booking} onClick={onSelected} />
                      </>
                    )
                  })}
                  {hiddenCount > 0 && !showAll && (
                    <span className="bookingUpcoming">
                      + {hiddenCount} more
                      <Button type="link" size="small" style={{ fontSize: '0.9em' }} onClick={() => setShowAll(true)}>
                        Show all
                      </Button>
                    </span>
                  )}
                </>
              ) : (
                <Paragraph className="note">You have no upcoming court bookings.</Paragraph>
              )}
            </div>
          </>
        </Col>
        <Col xs={24} sm={24} md={12} lg={15} xl={17} style={{ marginTop: '0em' }}>
          <div style={{ marginTop: '0em', marginBottom: '2em', verticalAlign: 'top' }}>
            <NextBookingMessage maxBookingTime={maxBookingTime} nextAllowed={nextAllowed} lastBooking={lastBooking} />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default UpcomingBookings
